<template>
  <div class="container">
    <h1 class="title">
      Welcome to GW2 Scratch
    </h1>
    <h2 class="subtitle">
      Guild Wars 2 tools and guides
    </h2>
    <div class="content">
      <blockquote cite="https://wiki.guildwars2.com/wiki/Skritt">
        <p>Skritt living conditions reflect their lazy nature. The only farms they run are those which
          require an absolute minimum of work to maintain, so they tend to prefer cooked meat and fungi
          harvested from underground. They prefer to live in large hollows or caverns, known as
          "scratches," using rocks and underground passageways to build a safe environment. They do have
          architectural ability, and build huts or structures within the main area of their hollow out of
          the items they scavenge. The high concentration of skritt in their scratches means they're at
          their most intelligent and most dangerous to any attacker.</p>
        <p>~ Guild Wars 2 Wiki</p>
      </blockquote>
    </div>
    <div class="columns">
      <div class="column is-4">
        <ProgramCard name="arcdps Log Manager"
                     status="A manager for all your recorded logs"
                     :image-url="require('@/assets/images/log-manager.png')"
                     :detail-route="{name: 'tools-manager'}"
        />
      </div>
      <div class="column is-4">
      <ProgramCard name="arcdps Clears"
                   status="arcdps plugin – check your weekly clears"
                   :image-url="require('@/assets/images/clears.png')"
                   :detail-route="{name: 'tools-arcdps-clears'}"
      />
      </div>
      <!--
      <div class="column is-3">
        <ProgramCard name="EVTC Inspector"
                     status="Explore data inside arcdps logs"
                     :image-url="require('@/assets/images/evtc-inspector.png')"
                     :detail-route="{name: 'tools-inspector'}"
        />
      </div>
      -->
    </div>
  </div>
</template>

<script>
import ProgramCard from "@/components/ProgramCard";

export default {
  name: 'home',
  components: {ProgramCard}
}
</script>
